export const PRODUCT_TYPES = {
  RECURRING: 'recurring',
  DONATION: 'donation'
};